import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CustomError } from '@modelos/errors/errors';

@Component({
    selector: 'app-error-dialog-component',
    templateUrl: './error-dialog-component.component.html',
    styleUrls: ['./error-dialog-component.component.css'],
    standalone: false
})


export class ErrorDialogComponentComponent implements OnInit {
  constructor(
    private dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) { }

  showErrorDetails = false
  isError: Error
  isHttpErrorResponse: HttpErrorResponse
  customError: CustomError
  title: string
  message: string

  ngOnInit(): void {
    const data = this.config.data;
    this.title = data.name ? data.name : 'Ocurrió un error'

    if (data instanceof Error) {
      const ignoredNames = ['ApolloError', 'GraphQLError', 'UserInputError', 'Error'];
      this.title = data.name && !ignoredNames.includes(data.name) ? data.name : 'Ocurrió un error';
      this.message = data.message ? data.message.replace(/^(ApolloError: |GraphQL error: |UserInputError: )/i, '').trim() : '';
    }
    if (data instanceof HttpErrorResponse) {
      this.title = data.name && data.name !== 'HttpErrorResponse' ? data.name : 'Ocurrió un error de conexión';
      this.message = data.error?.customMessage ? data.error.customMessage : data.status == 0 ? 'La aplicación no pudo conectarse con el servidor. De aviso a soporte técnico.' : data.message
    }
    if(data instanceof CustomError){
      this.customError = data
      this.title = data.name ? data.name : 'Ocurrió un error'
      this.message = data.message
    }
  }

  closeDialog() {
    this.dialogRef.close()
  }

  reload(){
    location.reload()
  }

}
